import { getNumbers } from './getNumbers';
export const normalizeValue = function () {
  let valueRaw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let length = arguments.length > 1 ? arguments[1] : undefined;
  return getNumbers(valueRaw).slice(0, length);
};